module.exports = __webpack_public_path__ + "img/sc-item-bg.03e37def.png";